import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  IconDefinition,
  faFacebook,
  faInstagram,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import * as styles from './contactInfos.module.scss';
import { LocaleLink } from '../localeLink/LocaleLink';

export type Social = {
  url: string;
  type: string;
};
interface IContactInfosProps {
  address?: string | null;
  tel?: string | null;
  webSite?: string | null;
  socials?: Social[];
  mainLocation?: string | null;
  mainLocationLibelle?: string | null;
}

const socialIcons: { [key: string]: IconDefinition } = {
  FACEBOOK: faFacebook,
  INSTAGRAM: faInstagram,
  TWITTER: faXTwitter,
  YOUTUBE: faYoutube,
};

export const ContactInfos = ({
  address,
  tel,
  webSite,
  socials,
  mainLocation,
  mainLocationLibelle,
}: IContactInfosProps) => {
  const { sanityObjetTouristique } = useStaticQuery(QUERY);
  const { lang } = usePageContext();

  const socialsWithIcon = socials?.map((social) => ({ ...social, icon: socialIcons[social.type] }));
  return (
    <div className={styles.wrapper}>
      {address && (
        <div className={styles.item}>
          <p>{sanityObjetTouristique?._rawAddressLabel?.[lang]}</p>
          <p>{address}</p>
        </div>
      )}
      {mainLocation && (
        <div className={styles.item}>
          <p>{mainLocationLibelle}</p>
          <p>{mainLocation}</p>
        </div>
      )}
      {tel && (
        <div className={styles.item}>
          <p>{sanityObjetTouristique?._rawTelLabel?.[lang]}</p>
          <p>{tel}</p>
        </div>
      )}
      {webSite && (
        <div className={styles.item}>
          <p>{sanityObjetTouristique?._rawWebsiteLabel?.[lang]}</p>
          <LocaleLink target="_blank" to={webSite}>
            {webSite}
          </LocaleLink>
        </div>
      )}
      {socialsWithIcon && socialsWithIcon?.length > 0 && (
        <div className={styles.socials}>
          <p>{sanityObjetTouristique?._rawSocials?.[lang]}</p>
          <div>
            {socialsWithIcon.map((social) => (
              <LocaleLink key={social.type} to={social.url} target="_blanck" external>
                <FontAwesomeIcon icon={social.icon} />
              </LocaleLink>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const QUERY = graphql`
  query ContactForm {
    sanityObjetTouristique {
      form {
        submitLabel
        _rawEmailLabel
        _rawFirstnameLabel
        _rawLastnameLabel
        _rawMessageLabel
        _rawObjectLabel
      }
      _rawTelLabel
      _rawWebsiteLabel
      _rawSocials
      _rawAddressLabel
    }
  }
`;
